<div class="container">
  <h2 class="my-5">Activities</h2>

  <section class="row" id="snorkeling">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Snorkeling</h3>
      <p>
        Yellow Leaf Bay, located on Taniti's southeastern coast, is renowned for its crystal-clear waters, white sand beaches,
        and vibrant marine life. The calm, shallow waters of the bay provide ideal conditions for snorkeling, especially for
        beginners and families with children. Local outfitters offer gear rentals and guided snorkeling excursions that allow
        visitors to explore colorful coral reefs teeming with tropical fish, sea turtles, and other native sea life. Educational
        briefings on reef conservation and marine safety are typically included, making this both a fun and environmentally
        responsible way to enjoy Taniti's underwater beauty.


      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row" id="ziplining">
    <div class="col-md-9">
      <h3>Ziplining</h3>
      <p>
        For those seeking adventure, Taniti's rainforest offers an exhilarating ziplining experience. Professionally operated
        zipline parks allow visitors to glide high above the forest floor, offering panoramic views of lush treetops, winding
        rivers, and hidden waterfalls. Safety is a top priority, with experienced guides providing thorough instruction and
        high-quality equipment. Participants can expect a series of platforms and lines of varying heights and lengths, making
        this activity accessible to beginners as well as thrill-seekers. Ziplining is a popular choice for families and groups
        looking to combine excitement with breathtaking natural scenery.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>

  <hr class="my-5">

  <section class="row" id="museum_gallery">
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
    <div class="col-md-9">
      <h3>Museums &amp; Galleries</h3>
      <p>
        Taniti is home to a growing number of museums and art galleries that celebrate the island's rich cultural heritage and
        creative spirit. Visitors can explore exhibits featuring traditional crafts, historical artifacts, and exhibits on Taniti's
        indigenous communities and colonial past. Local galleries showcase contemporary works by Tanitian artists, including
        paintings, sculpture, and mixed media inspired by the island's landscapes and traditions. Guided tours and occasional
        workshops provide deeper insight into the cultural significance of the collections. These venues offer a meaningful and
        educational experience for visitors interested in learning more about the island's history and artistic expression.
      </p>
    </div>
  </section>

  <hr class="my-5">

  <section class="row" id="entertainment">
    <div class="col-md-9">
      <h3>Entertainment</h3>
      <p>
        Most people visit Taniti to enjoy the beaches, explore the rainforest, and to visit the volcano. However, there are other
        things to do, including dancing at a new dance club, seeing a movie, taking helicopter rides, playing at an arcade, visiting
        art galleries, and bowling. Also, a nine-hole golf course should be operational by next year. Many of these activities are
        located in Merriton Landing, which is a rapidly developing area on the north side of Yellow Leaf Bay.
      </p>
    </div>
    <div class="col-md-3">
      <img src="../../../../assets/images/elementor-placeholder-image.webp" width="300" class="rounded-3">
    </div>
  </section>
</div>
